import { render, staticRenderFns } from "./AscDocMgmtHelpAboutDialog.vue?vue&type=template&id=72aea95a&"
import script from "./AscDocMgmtHelpAboutDialog.vue?vue&type=script&lang=js&"
export * from "./AscDocMgmtHelpAboutDialog.vue?vue&type=script&lang=js&"
import style0 from "./AscDocMgmtHelpAboutDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports